<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">

        <section slot="content" class="gz-form gz-form_white">
            <StaffAddEditForm />
        </section>        

    </gz-auth-view-template>
</template>

<script>
import StaffAddEditForm from '@/components/custom/admin/views/staff/StaffAddEditForm'

export default {
    name: 'StaffSingleInfo',

    components: {
        StaffAddEditForm
    }
}
</script>